import { ProtectedAdminLayout } from "@/components/admin/ProtectedAdminLayout";
import { PublicLayout } from "@/components/public/PublicLayout";
import { AdminLoginPage } from "@/pages/AdminLoginPage";
import { ChannelsPage } from "@/pages/ChannelsPage";
import { ContractsPage } from "@/pages/ContractsPage";
import { ConversationsPage } from "@/pages/ConversationsPage";
import { DashboardPage } from "@/pages/DashboardPage";
import { FaqPage } from "@/pages/FaqPage";
import { GuestChatPage } from "@/pages/GuestChatPage";
import { GuidesPage } from "@/pages/GuidesPage";
import { InviteAcceptPage } from "@/pages/InviteAcceptPage";
import { LandingPage } from "@/pages/LandingPage";
import { MembersPage } from "@/pages/MembersPage";
import { NotFoundPage } from "@/pages/NotFoundPage";
import { OtaMappingGuidePage } from "@/pages/OtaMappingGuidePage";
import { PrivacyPage } from "@/pages/PrivacyPage";
import { PropertiesPage } from "@/pages/PropertiesPage";
import { PropertyChatPage } from "@/pages/PropertyChatPage";
import { ReportsPage } from "@/pages/ReportsPage";
import { ReservationsPage } from "@/pages/ReservationsPage";
import { RoomBoardPage } from "@/pages/RoomBoardPage";
import { RoomTypesPage } from "@/pages/RoomTypesPage";
import { RoomsPage } from "@/pages/RoomsPage";
import { SuperAdminPage } from "@/pages/SuperAdminPage";
import { TermsPage } from "@/pages/TermsPage";
import { TimelinePage } from "@/pages/TimelinePage";
import { UserGuidePage } from "@/pages/UserGuidePage";
import { Route, Routes } from "react-router-dom";

export default function App() {
  return (
    <Routes>
      {/* Public marketing & docs */}
      <Route element={<PublicLayout />}>
        <Route path="/" element={<LandingPage />} />
        <Route path="/guide" element={<UserGuidePage />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
      </Route>
      {/* Public guest chat */}
      <Route path="/g/:token" element={<GuestChatPage />} />
      {/* Public property chat */}
      <Route path="/p/:token" element={<PropertyChatPage />} />
      {/* Admin */}
      <Route path="/admin/login" element={<AdminLoginPage />} />
      <Route path="/admin/invite/:token" element={<InviteAcceptPage />} />
      <Route path="/admin" element={<ProtectedAdminLayout />}>
        <Route index element={<DashboardPage />} />
        <Route path="conversations" element={<ConversationsPage />} />
        <Route path="rooms" element={<RoomsPage />} />
        <Route path="rooms/board" element={<RoomBoardPage />} />
        <Route path="room-types" element={<RoomTypesPage />} />
        <Route path="reservations" element={<ReservationsPage />} />
        <Route path="timeline" element={<TimelinePage />} />
        <Route path="guides" element={<GuidesPage />} />
        <Route path="contracts" element={<ContractsPage />} />
        <Route path="properties" element={<PropertiesPage />} />
        <Route path="channels" element={<ChannelsPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="members" element={<MembersPage />} />
        <Route path="super" element={<SuperAdminPage />} />
        <Route path="super/ota-guide" element={<OtaMappingGuidePage />} />
      </Route>

      {/* Fallback */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
